/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "./jobList.css";
import Search from "../../components/search/Search";
import FixBanner from "../../components/singleBanner/FixBanner";
import JobCard from "../../components/card/JobCard";
import { isNull } from "lodash";
import api from "../../api";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import SwiperCore, {
  EffectCoverflow,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/core";
import banner from "../../assets/Banner/jobpage.jpg";
import { Alert, Row, Col } from "reactstrap";

import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "react-js-loader";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";

import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";
import "swiper/components/effect-coverflow/effect-coverflow.scss";
import { API_IMAGE_URL, DEFAULT_JWT_TOKEN } from "../../app_constants";
import Logout from "../../logOut/Logout";
import { useHistory } from "react-router-dom";
import mobileSizeBanner from "../../assets/Banner/Dashboard@1.5x.png";
import { useMediaQuery } from "react-responsive";
import { defaultJobIcon } from "../../assets";
import JumbotronPlaceHolder from "../../components/JumbotronPlaceHolder";
import RMJobCard from "../../components/job-card/JobCard";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, EffectCoverflow]);

export default function JobList() {
  const isMobileDevice = useMediaQuery({
    query: "(min-device-width: 0px) and (max-device-width: 768px)",
  });

  const isTabletDevice = useMediaQuery({
    query: "(min-device-width: 481) and (max-device-width: 768px)",
  });

  const isLaptop = useMediaQuery({
    query: "(min-device-width: 769px) ",
  });

  const profile = useSelector((state) => state.profileData);
  const auth = useSelector((state) => state.auth_token);

  const dispatch = useDispatch();

  const [allJobList, setAllJobList] = useState([]);
  const [searchJobList, setSearchJobList] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [allLocation, setAllLocation] = useState([]);
  const [allContractType, setAllContractType] = useState([]);
  const [category, setCategory] = useState("");
  const [location, setLocation] = useState("");
  const [contractType, setContractType] = useState("");
  const [filterJobList, setFilterJobList] = useState([]);
  const [endPoint, setEndPoint] = useState(20);
  const [searchText, setSearchText] = useState("");
  const [singleCategory, setSingleCategory] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");

  const shouldeReloadJobList = useSelector(
    (state) => state.shouldeReloadJobList
  );
  const categoryNm = useSelector((state) => state.categoryNm);
  const [alertClr, setAlertClr] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        setMessage("");
        setAlertClr("");
        setShowAlert(false);
      }, 3000);
    }
  }, [showAlert]);

  // useEffect(() => {
  //   console.log("CATTTT name", categoryNm);
  //   setCategory(categoryNm);
  // }, [category]);

  useEffect(() => {
    console.log("end point list", endPoint);
  }, [endPoint]);

  useEffect(() => {
    getJobList();
    dispatch({
      type: "shouldeReloadJobList/save",
      shouldeReloadJobList: false,
    });
  }, [shouldeReloadJobList]);

  const getJobList = () => {
    // 2- verified, 1- Non verified, 0- guest user
    console.log("PROFILE ", profile);

    console.log("user type ", profile);
    if (profile) {
      if (profile.status === 0 || profile.status === 1) {
        path = "gu";
        authToken = DEFAULT_JWT_TOKEN;
      } else if (profile.status === 2) {
        path = "lu";
        authToken = auth;
      }
    } else {
      var path = "gu";
      var authToken = DEFAULT_JWT_TOKEN;
    }

    console.log("path info ", path, " ", authToken);

    setIsLoading(true);
    authToken &&
      api.job
        .fetchAllJob(path, authToken)
        .then((result) => {
          console.log("ALL job Result => ", result);
          if (result.resultCode === 1) {
            setAllJobList(result.resultData.jobList);
          } else {
            setAllJobList([]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          if (
            !!error.response &&
            !!error.response.status &&
            error.response.status === 401
          ) {
            console.log("logOutClick");
            Logout(dispatch, history, false);
          }
          if (error.message === "Network Error") {
            setMessage("Please check your network connection!");
            setAlertClr("danger");
            setShowAlert(true);
          }
        });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch({ type: "setCurrentLink", currentLink: "/jobList" });
    allCategoryList();
    getAllMaster();

    // window.scrollTo(0, 0);
  }, []);

  const getAllMaster = () => {
    api.job
      .allMaster()
      .then((result) => {
        console.log("MASTE LOCATION ", result);
        if (result.resultCode === 1) {
          setAllLocation(result.resultData.locationList);
          setAllContractType(result.resultData.contractTypeList);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          !!error.response &&
          !!error.response.status &&
          error.response.status === 401
        ) {
          console.log("logOutClick");
          Logout(dispatch, history, false);
        }
        if (error.message === "Network Error") {
          setMessage("Please check your network connection!");
          setAlertClr("danger");
          setShowAlert(true);
        }
      });
  };

  const allCategoryList = () => {
    setIsLoading(true);
    api.category
      .allCategory()
      .then((result) => {
        console.log("ALL category Result => ", result);
        if (result.resultCode === 1) {
          setAllCategory(result.resultData.jobCategoryList);
        } else {
          setAllCategory([]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        if (
          !!error.response &&
          !!error.response.status &&
          error.response.status === 401
        ) {
          console.log("logOutClick");
          Logout(dispatch, history, false);
        }
        if (error.message === "Network Error") {
          setMessage("Please check your network connection!");
          setAlertClr("danger");
          setShowAlert(true);
        }
      });
  };

  //filter with location, contratct type and category
  useEffect(() => {
    var filterList = JSON.parse(JSON.stringify(allJobList));

    if (category) {
      filterList = filterList.filter((item) => {
        // console.log("aply filtr cat ", item)
        return item.categoryName === category;
      });
    }

    var locItem = [];
    if (location) {
      filterList = filterList.filter((item) => {
        item.locationNmList.map((i) => {
          if (i === location) {
            locItem.push(item);
          }
        });
      });
      filterList = locItem;
    }

    var contractItem = [];
    if (contractType) {
      filterList = filterList.filter((item) => {
        // return (item.contractTypeNmList.toString() === contractType)

        item.contractTypeNmList.map((i) => {
          if (i === contractType) {
            contractItem.push(item);
          }
        });
      });
      // console.log("SELECTED CATE loc", contractItem);
      filterList = contractItem;
    }

    console.log("SELECTED CATE ", filterList);
    setFilterJobList(filterList);
  }, [category, location, contractType, allJobList]);

  useEffect(() => {
    console.log("Search Text ", searchText);
    console.log("filter List  ", filterJobList);
    console.log("List  ", allJobList);

    var searchArr = [];
    // Search Applied

    if (searchText) {
      searchArr = filterJobList.filter((item, idx) => {
        console.log("ITEM SEARCH ", item);
        return (
          item.jobTitle.toLowerCase().includes(searchText.toLowerCase()) ||
          item.oneLinerDescription
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.categoryName.toLowerCase().includes(searchText.toLowerCase()) ||
          item.locationNmList
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.contractTypeNmList
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      });
    } else {
      searchArr = JSON.parse(JSON.stringify(filterJobList));
    }
    // setEndPoint(20);

    console.log("SEARCH LOc", searchArr);
    setSearchJobList(searchArr);
  }, [searchText, filterJobList]);

  return (
    <React.Fragment>
      <Alert className="alert-position" isOpen={showAlert} color={alertClr}>
        {message}{" "}
      </Alert>
      <JumbotronPlaceHolder>
        {isMobileDevice && (
          <img
            loading
            src={mobileSizeBanner}
            alt="First slide"
            style={{ width: "100%", height: "100%" }}
          />
        )}

        {isLaptop && (
          <img
            loading
            src={banner}
            alt="second slide"
            style={{ width: "100%", height: "100%" }}
          />
        )}
        <div className="jobbanner"></div>
        <div className="banner-details">
          <h1
            className="banner-title"
            style={{
              display: "flex",
              justifyContent: "flex-start",
              color: "white",
              textAlign: "start",
            }}
          >
            Get the right job in <br />
            seconds with us!{" "}
          </h1>
        </div>
      </JumbotronPlaceHolder>

      {/* <div style={{ position: "relative" }}>
        {isMobileDevice && (
          <img
            loading
            src={mobileSizeBanner}
            alt="First slide"
            style={{ width: "100%", height: "100%" }}
          />
        )}

        {isLaptop && (
          <img
            loading
            src={banner}
            alt="second slide"
            style={{ width: "100%", height: "100%" }}
          />
        )}
        <div className="jobbanner"></div>
        <div className="banner-details">
          <h1
            className="banner-title"
            style={{
              display: "flex",
              justifyContent: "flex-start",
              color: "white",
              textAlign: "start",
            }}
          >
            Get the right job in <br />
            seconds with us!{" "}
          </h1>
        </div>
      </div> */}

      <p className="banner-overlay"></p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "absolute",
          top: "200px",
          left: "50%",
        }}
      >
        {isLoading && (
          <Loader
            type="spinner-cub"
            bgColor={"black"}
            title={"Loading..."}
            size={100}
          />
        )}
      </div>
      <h3 className="large-header pl-5 pt-5 text-start">
        Job Function Categories
      </h3>
      <hr className="cust-underline ml-5 mb-5" />
      <div className="product-swiper-container mt-5">
        <Swiper
          className="book-swiper d-flex justify-content-space-around"
          slidesPerView={5}
          spaceBetween={1}
          loop={true}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 180,
            },
            360: {
              slidesPerView: 2,
              spaceBetween: 170,
            },
            400: {
              slidesPerView: 2,
              spaceBetween: 170,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 3,
              spaceBetween: 190,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 3,
              width: 640,
              spaceBetween: 180,
            },
            // when window width is >= 768px
            768: {
              width: 768,
              slidesPerView: 5,
              spaceBetween: 190,
            },
          }}
          navigation={true}
        >
          {allCategory.map((data, idx) => {
            if (data.jobCount > 0) {
              return (
                <SwiperSlide key={idx}>
                  <div
                    className="service-card"
                    style={
                      category === data.categoryName
                        ? {
                            border: "1px solid grey",
                            boxShadow: "inset 0 0 20px grey",
                          }
                        : { background: "white" }
                    }
                    onClick={() => {
                      // setCategory(data.categoryName)
                      // console.log("CATEGPRY", category)
                      var cat = data.categoryName;
                      if (category === "") {
                        setCategory(data.categoryName);
                      } else {
                        setCategory("");
                      }
                      dispatch({
                        type: "category/save",
                        categoryNm: data.categoryName,
                      });
                    }}
                  >
                    <img
                      src={
                        data.iconPath
                          ? API_IMAGE_URL + data.iconPath.toString()
                          : defaultJobIcon
                      }
                    />
                    <h3 className="mt-5">
                      {data.categoryName}
                      {`(${data.jobCount})`}
                    </h3>
                  </div>
                </SwiperSlide>
              );
            }
          })}
        </Swiper>
      </div>
      <Row className="d-flex justify-content-center">
        <Col xl="5 " lg="5" md="5 " sm="8" xs="11 ">
          <select
            style={{ backgrounfColor: "white" }}
            className="input-dropdown-job mr-4"
            value={location}
            onChange={(e) => {
              setLocation(e.target.value);
            }}
          >
            <option style={{ color: "gray" }}>Filter By Location</option>
            {allLocation.map((loc, idx) => {
              return <option>{loc.locationName}</option>;
            })}
          </select>
        </Col>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="button-tooltip-2">Clear filter</Tooltip>}
        >
          <i
            class="fa fa-times position-clear"
            onClick={() => {
              setLocation("");
            }}
            aria-hidden="true"
          ></i>
        </OverlayTrigger>
        <Col xl="5 " lg="5" md="5 " sm="8" xs="11">
          <select
            style={{ backgrounfColor: "white" }}
            className="input-dropdown-job"
            value={contractType}
            onChange={(e) => {
              setContractType(e.target.value);
            }}
          >
            <option style={{ color: "gray" }}>Filter By Contract Type</option>
            {allContractType.map((cont, idx) => {
              return <option>{cont.contractTypeName} </option>;
            })}
          </select>
        </Col>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="button-tooltip-2">Clear filter</Tooltip>}
        >
          <i
            class="fa fa-times position-clear"
            onClick={() => {
              setContractType("");
            }}
            aria-hidden="true"
          ></i>
        </OverlayTrigger>
      </Row>

      <Search searchText={searchText} setSearchText={setSearchText} placeholder="Search by all job functions"/>

      <h3 className=" text-center">Recommended Jobs</h3>
      <div>
        <div className="responsive-lists">
          {searchJobList.length === 0 ? (
            <h3 style={{ marginTop: "4rem" }}>No, Result Found !!</h3>
          ) : (
            <JobCard
              data={searchJobList}
              endPoint={endPoint}
              setEndPoint={setEndPoint}
            />
          )}
        </div>
      </div>
      <div
        style={{ marginTop: "5rem", display: "flex", justifyContent: "center" }}
      >
        {!(endPoint > searchJobList.length) && (
          <Button
            className="view-btn"
            onClick={() => {
              setEndPoint(endPoint + 20);
              // dispatch({ type: 'endPoint/save', endPointMap: (endPoint + 20) })
            }}
          >
            Load More
          </Button>
        )}
      </div>
    </React.Fragment>
  );
}
